// Module
var code = "<div class=\"viewer-root\" v-bind:class=\"className\" v-if=\"rootVisible\"></div>\n<div class=\"viewer-root\" v-bind:class=\"className\" v-else-if=\"loaderVisible\">\n  <loader-root>Waiting for the first content...</loader-root>\n</div>\n";
// Exports
export default code;